import React from "react";

const ArticleVisitRequirements: React.FC = () => {
    return (
        <section className="mt-8">
            <div className="flex gap-3 mb-4">
                <div className="w-7 min-w-7 h-7 rounded-full bg-primary flex items-center justify-center">
                    <span className="text-on-primary text-xs font-semibold">i</span>
                </div>
                <div>
                    <h2 className="text-lg font-semibold text-on-surface my-0">
                        Jak przygotować się do wizyty
                    </h2>
                    <p className="text-[15px] leading-6 text-on-surface/80">
                        Ta krótka lista pomoże Ci zabrać wszystko, co najważniejsze na wizytę u specjalisty.
                    </p>
                </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div className="rounded-xl bg-[#ECF3F4] p-5 space-y-2">
                    <p className="text-[14px] font-semibold text-primary uppercase tracking-wide">
                        1. Wymagane
                    </p>
                    <ul className="space-y-1.5 text-[15px] text-on-surface/90 pl-4 list-disc">
                        <li>Skierowanie (jeśli jest wymagane)</li>
                        <li>Dokument tożsamości</li>
                        <li>
                            Dokumentacja medyczna, w tym:
                            <ul className="mt-1 space-y-1 pl-4 list-disc">
                                <li>zdjęcia RTG, MRI, CT wraz z opisami (także wcześniejsze)</li>
                                <li>wcześniejsze wypisy ze szpitala</li>
                            </ul>
                        </li>
                        <li>Lista przyjmowanych leków</li>
                        <li>Spis objawów i czasu ich trwania</li>
                    </ul>
                </div>

                <div className="rounded-xl bg-on-surface/3 p-5 space-y-2">
                    <p className="text-[14px] font-semibold text-on-surface uppercase tracking-wide">
                        2. Opcjonalne
                    </p>
                    <ul className="space-y-1.5 text-[15px] text-on-surface/80 pl-4 list-disc">
                        <li>wyniki badań krwi, USG i innych badań dodatkowych</li>
                        <li>nazwa stosowanych ortez, butów ortopedycznych, wcześniejszych urazów</li>
                        <li>
                            informacje o dotychczasowym przebiegu leczenia:
                            <ul className="mt-1 space-y-1 pl-4 list-disc">
                                <li>czy objawy się zmieniły</li>
                                <li>czy stosowane leki / rehabilitacja pomagają</li>
                            </ul>
                        </li>
                        <li>(opcjonalnie) krótkie nagranie pokazujące problem — np. sposób chodzenia, zakres ruchu</li>
                        <li>lista pytań do lekarza</li>
                    </ul>
                </div>
            </div>
        </section>
    );
};

export default ArticleVisitRequirements;
